import { createAsyncThunk } from '@reduxjs/toolkit';

import { get, put, post, deleteRequest } from '@/api';
import { successHandler } from 'common/utils/notifications';

export const getCrewMatrices = createAsyncThunk(
  'GET_CREW_MATRICES',
  async (params, { rejectWithValue }) => {
    try {
      const res = await get(`/crew-matrices`);

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const createCrewMatrix = createAsyncThunk(
  'CREATE_CREW_MATRIX',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await post('/crew-matrices', params);

      dispatch(successHandler({ title: 'Success!', message: 'Created successfully' }));

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const updateCrewMatrix = createAsyncThunk(
  'UPDATE_CREW_MATRIX',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const { id, table, ...rest } = params;

      const res = await put(`/crew-matrices/${id}`, { ...rest });

      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const deleteCrewMatrix = createAsyncThunk(
  'DELETE_CREW_MATRIX',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const { id, ...rest } = params;

      const res = await deleteRequest(`/crew-matrices/${id}`, { ...rest });

      dispatch(successHandler({ title: 'Success!', message: 'Deleted successfully' }));

      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
